import React from 'react';
import { motion, AnimateSharedLayout } from 'framer-motion';
import Disclosure from '../components/Disclosure';

const FAQContent = [
  {
    number: 1,
    question: 'How do I place an order?',
    answer: (
      <div>
        <p>Follow the steps below to place an order on the Jeetar App</p>
        <ul className='pl-5 mt-3 space-y-2 text-sm font-medium list-decimal list-inside list lg:text-lg'>
          <li>Sign in to your Jeetar account</li>
          <li>Select from any of our services</li>
          <li>Search for the products you need</li>
          <li>Add items to cart</li>
        </ul>
      </div>
    ),
  },
  {
    number: 2,
    question: 'How do I know if my order has been confirmed?',
    answer:
      'Once you order your items, a confirmation email will be sent to your email address.',
  },
  {
    number: 3,
    question:
      'My payment was successfully processed but I did not receive an order confirmation. What should I do? ',
    answer:
      'After making a successful payment, please wait a few minutes for your order to be confirmed while our team confirms your payment.',
  },
  {
    number: 4,
    question: 'How long does it take to receive my items?',
    answer: 'All ordered items will be delivered in 20 minutes or less.',
  },
  {
    number: 5,
    question: 'How can I track my order?',
    answer:
      'To track your order, log in to your Jeetar account and go to the activity page. You’ll receive push notifications at each stage of the order process to keep you updated on the status of your order.',
  },
  {
    number: 6,
    question: 'Will I be contacted before receiving my package?',
    answer:
      'Yes! Before delivering your ordered items, our Jeetar Riders will call you. You will also receive notifications on your app regarding the status of your order, from the packaging stage to the delivery stage.',
  },
  {
    number: 7,
    question: 'What should I do when I have a complaint?',
    answer: (
      <p className='leading-[2]'>
        To lodge a complaint, send an email to{' '}
        <a href='mailto:hello@jeetar.com' className='underline text-kBlue'>
          hello@jeetar.com
        </a>
        . Our support team is always available to take note of your complaint
        and provide you with a solution. Alternatively, you can utilize the
        app's support icon to speak with us on Whatsapp. Kindly note that we
        will never ask you for your bank card details.
      </p>
    ),
  },
  {
    number: 8,
    question: 'How do I cancel my order?',
    answer:
      'Be informed that an order can not be cancelled after payment is made. For refund policy click here',
  },
  {
    number: 9,
    question: 'How do I pay on Jeetar?',
    answer:
      'Payments can only be made on Jeetar using your bank debit cards. This is due to our COVID-19 compliance processes.',
  },
  {
    number: 10,
    question: 'How do I change my account password?',
    answer: (
      <div>
        <p>To change your Jeetar account password:</p>
        <ul className='pl-5 my-3 space-y-2 text-sm font-medium list-decimal list-inside list lg:text-lg'>
          <li>Open your Jeetar app</li>
          <li>Input your phone number or email address</li>
          <li>Click on “Forgot Password”</li>
          <li>Add your phone number</li>
          <li>Click “Send reset code” to receive an OTP</li>
        </ul>
        <p>Check your email address for the OTP to change your password.</p>
      </div>
    ),
  },
  {
    number: 11,
    question:
      "Would my account be deactivated if I don't use it for a long time?",
    answer:
      'No, your account will not be deactivated or deleted if it hasn’t been in use for a long time. However, be an active user of the Jeetar app to receive cashbacks on items and enjoy unbeatable discounts.',
  },
];

const FaqSection = () => {
  return (
    <AnimateSharedLayout>
      <motion.section
        layoutId='faq'
        data-aos=''
        id='FAQ'
        className='pb-14 px-4 lg:max-h-auto pt-[4.5rem] lg:pt-[7.2rem] lg:px-[17rem] lg:pb-[8rem] flex flex-col items-center bg-faq-section-pattern'>
        <h6 className='mb-4 text-2xl leading-[2rem] font-bold text-kBlack lg:text-[2.5rem] lg:leading-[3.4rem]'>
          Frequently Asked Questions
        </h6>
        <p className='text-kGray text-sm max-w-[18rem] lg:max-w-[40rem] lg:text-2xl mb-[1rem] lg:w-[39rem] text-center'>
          Get answers to the questions you have to understand how things are
          done
        </p>
        <motion.div>
          {FAQContent.map((item) => (
            <Disclosure key={item.number} {...item} />
          ))}
        </motion.div>
      </motion.section>
    </AnimateSharedLayout>
  );
};

export default FaqSection;
